/**
 * Встроенное уведомление (без window.alert), единый вид в чате и карточке сделки.
 * variant: success | warning | error | info
 */
export function InlineBanner({ message, variant = "warning", onClose, className = "" }) {
  if (!message) return null;
  const mod =
    variant === "success"
      ? "inlineBanner--success"
      : variant === "error"
        ? "inlineBanner--error"
        : variant === "info"
          ? "inlineBanner--info"
          : "inlineBanner--warning";
  return (
    <div
      className={`inlineBanner ${mod}${className ? ` ${className}` : ""}`.trim()}
      role="status"
      aria-live="polite"
    >
      <span className="inlineBanner__text">{message}</span>
      {onClose ? (
        <button type="button" className="inlineBanner__close" onClick={onClose} aria-label="Закрыть">
          ×
        </button>
      ) : null}
    </div>
  );
}
